import { PIXI } from "../../engine/tbPIXI";
import { LoadManager } from "./LoadManager";
var BaseLoader = /** @class */ (function () {
    function BaseLoader() {
        this._pixiLoader = new PIXI.loaders.Loader();
    }
    /**
     * Prepares the given asset(s) for loading
     * @param {any} assetInfo
     */
    BaseLoader.prototype.prepareAsset = function (assetInfo) {
        this._assetInfo = assetInfo;
        this._pixiLoader.add(assetInfo);
        this._pixiLoader.onError.add(function (error, loader, resource) {
            LoadManager.logLoadInfo("LOAD ERROR", error, loader, resource);
            console.error(error, resource);
        });
    };
    /**
     * Loads the prepared asset(s)
     * @param {Function} onComplete
     * @param {Function} onFailed
     */
    BaseLoader.prototype.loadAsset = function (onComplete, onFailed) {
        this._pixiLoader.load(function (data) {
            if (data.resources === undefined) {
                onFailed("Failed to get resources after loading");
            }
            else {
                onComplete(data.resources);
            }
        });
    };
    /**
     * Resets the loader and re-prepares the assets
     */
    BaseLoader.prototype.reset = function () {
        this._pixiLoader.reset();
        this.prepareAsset(this._assetInfo);
    };
    BaseLoader.prototype.getResource = function (name) {
        return this._pixiLoader.resources[name];
    };
    return BaseLoader;
}());
export { BaseLoader };
